<div class="layout-ParentDiv innerDiv">
    <div class="layout-dashboard">
        <div class="mainDivHeader">
            <div class="leftdiv">
                <h4>{{ userName }}'s Court Bookings <span class="badge">{{totalRecords }}</span></h4>
            </div>
            <div class="rightDiv">
                <!-- <button class="exportBTn" (click)="exportTournamentExcel()"> <span><img
							src="../../../assets/images/backend-image/header/exportIcon.svg" alt=""></span> Download
					tournament report</button> -->
            </div>
        </div>

        <div class="mainDivBody">
            <div class="date-filterDiv">
                <ul class="filtersList">
                    <li>
                        <p-dropdown inputId="searchfield" [options]="searchBy" [(ngModel)]="searchby"
                            optionLabel="label"></p-dropdown>
                    </li>
                    <li>
                        <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
                            [(ngModel)]="startDate" class="p-calendar w-100" inputId="calendar" dateFormat="dd/mm/yy"
                            [showIcon]="true" placeholder="FROM: dd / mm / yy"></p-calendar>
                    </li>
                    <li>
                        <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
                            [(ngModel)]="endDate" class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy"
                            [showIcon]="true" placeholder="To: dd / mm / yy"></p-calendar>
                    </li>
                    <li>
                        <!-- <button pButton pRipple label="Search" class="p-button p-mr-1 p-mb-" (click)="loadWallet($event)"></button> -->
                        <button (click)="loadAcademyCourtBookingDetails(lazyLoadEvent)" class="searchFilterBtn">
                            <img src="../../../assets/images/backend-image/common-images/search.svg" alt="">
                        </button>
                    </li>
                    <li>
                        <!-- <button pButton label="Clear Filters" class="p-button-outlined p-mr-2 p-mb-2" icon="pi pi-filter-slash" (click)="clear()"></button> -->
                        <button (click)="clear()" class="clearFilterBtn">
                            <img src="../../../assets/images/backend-image/common-images/delete.svg" alt="">
                            <span>Clear All</span>
                        </button>
                    </li>
                </ul>
            </div>
            <div class="maintableDiv">
                <div class="tableParanet">
                    <p-table id="vdtnetable10" #dt [value]="playerCourtBookingList" [paginator]="true" [rows]="10"
                        [rowsPerPageOptions]="paginationOption" [lazy]="true" scrollHeight="auto"
                        scrollDirection="horizontal" [totalRecords]="totalRecords" [loading]="loading"
                        [scrollable]="true" cellpadding="0" class="transaction-history"
                        styleClass="p-datatable-gridlines p-datatable-striped"
                        (onLazyLoad)="loadAcademyCourtBookingDetails($event)" aria-describedby="vdtnetable10_info">
                        <ng-template pTemplate="header">
                            <tr>
                                <th pSortableColumn="tournamentName" class="orderTD" rowspan="1" colspan="1">
                                    <div>Court
                                        <p-sortIcon field="tournamentName"></p-sortIcon>
                                    </div>
                                </th>
                                <th pSortableColumn="matchName" class="NameTD" rowspan="1" colspan="1">
                                    <div>Academy Name
                                        <p-sortIcon field="matchName"></p-sortIcon>
                                    </div>
                                </th>
                                <th pSortableColumn="agegroupName" class="dobTd" rowspan="1" colspan="1">
                                    <div>Booking Date
                                        <p-sortIcon field="agegroupName"></p-sortIcon>
                                    </div>
                                </th>
                                <th pSortableColumn="entryFee" class="courtTypeTd" rowspan="1" colspan="1">
                                    <div>Court type
                                        <p-sortIcon field="entryFee"></p-sortIcon>
                                    </div>
                                </th>
                                <th pSortableColumn="lastdateofwithdraw" class="sportTypeTd" rowspan="1" colspan="1">
                                    <div> Sport type
                                        <p-sortIcon field="lastdateofwithdraw"></p-sortIcon>
                                    </div>
                                </th>
                                <th pSortableColumn="lastdateofwithdraw" class="bookingStatusTd" rowspan="1"
                                    colspan="1">
                                    <div> Booking Status
                                        <p-sortIcon field="lastdateofwithdraw"></p-sortIcon>
                                    </div>
                                </th>
                                <th pSortableColumn="tournamentEndDate" class="slotsTd viewBtnTd" rowspan="1"
                                    colspan="1">
                                    <div>Slots
                                        <p-sortIcon field="tournamentEndDate"></p-sortIcon>
                                    </div>
                                </th>
                                <th pSortableColumn="tournamentEndDate" class="totalAmountPayableTd" rowspan="1"
                                    colspan="1">
                                    <div>Slot total amount
                                        <p-sortIcon field="tournamentEndDate"></p-sortIcon>
                                    </div>
                                </th>
                                <th class="actionTD p-frozen-column" rowspan="1" colspan="1">
                                    <div>Action

                                    </div>
                                </th>

                            </tr>
                            <tr>
                                <th [ngSwitch]="courtName" pfrozencolumn="" class="orderTD">
                                    <input pInputText type="text"
                                        (keyup.enter)="dt.filter($event.target.value, 'courtName', 'contains')"
                                        [value]="dt.filters['courtName'] ? dt.filters['courtName'].value : ''" />
                                </th>
                                <th [ngSwitch]="academyName" class="NameTD">
                                    <input pInputText type="text"
                                        (keyup.enter)="dt.filter($event.target.value, 'academyName', 'contains')"
                                        [value]="dt.filters['academyName'] ? dt.filters['academyName'].value : ''" />
                                </th>
                                <th [ngSwitch]="receiptId" class="dobTd">
                                    <!-- <p-calendar #pCalendarId class="p-column-filter" readonlyInput="true"
                                        inputId="calendar" dateFormat="dd-mm-yy"
                                        (onSelect)="dt.filter($event,'expiryDate', 'dateIs')"
                                        [showIcon]="true" appendTo="body" monthNavigator="true" yearNavigator="true"
                                        yearRange="2000:2030" showButtonBar="true"
                                        [(ngModel)]="expiryvalue"></p-calendar> -->
                                </th>
                                <th [ngSwitch]="courtType" class="courtTypeTd">
                                    <p-dropdown #pDropDownId1 [options]="courtTypeList"
                                        (onChange)="dt.filter($event.value, 'courtType', 'equals')"
                                        styleClass="p-column-filter" placeholder="Select Court" [showClear]="true"
                                        appendTo="body">
                                        <ng-template let-option pTemplate="item">
                                            <span
                                                [class]="'customer-badge status-' + option.value">{{option.label}}</span>
                                        </ng-template>
                                    </p-dropdown>
                                </th>
                                <th [ngSwitch]="sportType" class="sportTypeTd">
                                    <p-dropdown #pDropDownId2 [options]="sportList"
                                        (onChange)="dt.filter($event.value, 'sportType', 'equals')"
                                        styleClass="p-column-filter" placeholder="Select Sport" [showClear]="true"
                                        appendTo="body">
                                        <ng-template let-option pTemplate="item">
                                            <span
                                                [class]="'customer-badge status-' + option.value">{{option.label}}</span>
                                        </ng-template>
                                    </p-dropdown>
                                </th>

                                <th [ngSwitch]="bookingStatus" class="bookingStatusTd">
                                    <p-dropdown #pDropDownId3 [options]="bookingStatuses"
                                        (onChange)="dt.filter($event.value, 'bookingStatus', 'equals')"
                                        styleClass="p-column-filter" placeholder="Select Status" [showClear]="true"
                                        appendTo="body">
                                        <ng-template let-option pTemplate="item">
                                            <span
                                                [class]="'customer-badge status-' + option.value">{{option.label}}</span>
                                        </ng-template>
                                    </p-dropdown>
                                </th>
                                <th [ngSwitch]="invoiceId" class="slotsTd">
                                    <!-- <input pInputText type="text"
                                        (keyup.enter)="dt.filter($event.target.value, 'invoiceId', 'contains')"
                                        [value]="dt.filters['invoiceId'] ? dt.filters['invoiceId'].value : ''" /> -->
                                </th>
                                <th [ngSwitch]="slotTotalAmount" class="totalAmountPayableTd"
                                    [ngClass]="hide ? 'hide-col text-nowrap col-200 ' : 'show-col text-nowrap col-200'">
                                    <input pInputText type="text"
                                        (keyup.enter)="dt.filter($event.target.value, 'slotTotalAmount', 'contains')"
                                        [value]="dt.filters['slotTotalAmount'] ? dt.filters['slotTotalAmount'].value : ''" />
                                </th>
                                <th class="actionTD text-nowrap p-element p-frozen-column" pfrozencolumn=""
                                    alignfrozen="right">
                                    <!-- <button pButton pRipple label="Columns" icon="pi pi-plus"
                                        [ngClass]="hide ? 'show-col p-button p-button-secondary p-button-rounded ' : 'hide-col p-button-secondary p-button-rounded'"
                                        (click)="addColumns()"></button>
                                    <button pButton pRipple label="Columns" icon="pi pi-minus"
                                        [ngClass]="hide ? 'hide-col p-button p-button-rounded' : 'show-col p-button p-button-rounded'"
                                        (click)="removeColumns()"></button> -->
                                </th>
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="body" let-playerCourtBooking let-rowIndex="rowIndex">
                            <tr>
                                <td class="orderTD"><span class="rin-type-label state-finished" tooltipPosition="top">

                                        {{playerCourtBooking?.courtdata?.courtName}}
                                    </span></td>
                                <td class="NameTD"><span class="rin-type-label state-finished">
                                        {{playerCourtBooking?.academyName}}
                                    </span></td>
                                <td class="dobTd"><span class="rin-type-label state-finished">
                                        {{playerCourtBooking?.bookingDate | date:'dd-MM-yyyy'}}
                                    </span></td>
                                <td class="courtTypeTd"><span class="rin-type-label state-finished">
                                        {{playerCourtBooking?.courtdata?.courtType}}
                                    </span></td>
                                <td class="sportTypeTd"><span class="rin-type-label state-finished">
                                        {{playerCourtBooking?.sportsdata?.name}}
                                    </span></td>
                                <td class="bookingStatusTd"><span class="rin-type-label state-finished">
                                        {{playerCourtBooking?.bookingStatus}}
                                    </span></td>
                                <td class="slotsTd viewBtnTd"><span class="rin-type-label state-finished">
                                        <button pButton type="button" icon="pi pi-eye" label="View"
                                            (click)="onShowSlots(playerCourtBooking)"></button>
                                    </span></td>
                                <td class="totalAmountPayableTd"><span class="rin-type-label state-finished">
                                        {{playerCourtBooking?.totalAmountPayable | number:'1.2-2'}}
                                    </span></td>
                                <td class="actionTD p-frozen-column">
                                    <ul class="actionList">
                                        <li>
                                            <a [href]="playerCourtBooking?.invoiceFile" target="_blank" download>
                                                <button class="downloadbtn">
                                                    <img
                                                        src="../../../../../assets/images/backend-image/common-images/downloadbtn.svg">
                                                </button>
                                            </a>

                                        </li>
                                        <!-- *ngIf="checkBookingDateValidator(academyCourtBooking) && (academyCourtBooking?.bookingStatus !== 'Rejected' && academyCourtBooking?.bookingStatus !== 'Cancelled' && academyCourtBooking?.bookingStatus !== 'Completed')" -->
                                        <li
                                            *ngIf="checkBookingDateValidator(academyCourtBooking) && (academyCourtBooking?.bookingStatus !== 'Rejected' && academyCourtBooking?.bookingStatus !== 'Cancelled' && academyCourtBooking?.bookingStatus !== 'Completed')">
                                            <button tooltipPosition="bottom" pTooltip="Reject Booking" class="rejectbtn"
                                                (click)="onRejectBooking(academyCourtBooking)">
                                                <img
                                                    src="../../../../../assets/images/backend-image/common-images/rejectbtn.svg">
                                            </button>
                                        </li>
                                        <li *ngIf="checkBookingDateValidator(playerCourtBooking) && (playerCourtBooking?.bookingStatus !== 'Rejected' && playerCourtBooking?.bookingStatus !== 'Cancelled' && playerCourtBooking?.bookingStatus !== 'Completed')">
                                            <button tooltipPosition="bottom" pTooltip="Cancel Booking" class="rejectbtn"
                                               (click)="onCancelBooking(playerCourtBooking)">
                                                <img
                                                    src="../../../../../assets/images/backend-image/common-images/rejectbtn.svg">
                                            </button>
                                        </li>

                                    </ul>

                                    <!-- <div class="status-buttons">
                                        <a [href]="playerCourtBooking?.invoiceFile" target="_blank" download>
                                            <button pButton class="btn btn-success mx-2" icon="pi pi-download"
                                                id="withdrawal-btn1" tooltipPosition="bottom"
                                                pTooltip="Download Invoice"></button>
                                        </a>
                                        <button pButton class="btn btn-danger" icon="pi pi-times"
                                            (click)="onCancelBooking(playerCourtBooking)"
                                            *ngIf="checkBookingDateValidator(playerCourtBooking) && (playerCourtBooking?.bookingStatus !== 'Rejected' && playerCourtBooking?.bookingStatus !== 'Cancelled' && playerCourtBooking?.bookingStatus !== 'Completed')"
                                            id="withdrawal-btn2" tooltipPosition="bottom"
                                            pTooltip="Cancel Booking"></button>
                                    </div> -->
                                </td>
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="7">Court Bookings not found.</td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>
        </div>
        <p-toast key="toastmsg"></p-toast>
        <p-confirmDialog [style]="{width: '445px'}" id="confirmDialog"></p-confirmDialog>

        <p-dialog header="Slots" modal="true" [(visible)]="isSlotsAvailable"  [style]="{width: '402px'}" id="slotsModal"  [draggable]="false">
              <div class="timeSlotesList">
                <div class="mainList" *ngIf="morningSlots.length !== 0">
                     <h5 class="h6" *ngIf="morningSlots.length !== 0">MORNING SLOTS ({{ morningSlots.length }})</h5>
                    <ul>
                        <li *ngFor="let morningSlot of morningSlots; let i=index;">
                            <span>{{ morningSlot?.startTime }} - {{ morningSlot?.endTime }}</span>
                            <span>₹ {{morningSlot?.price}}</span>
                        </li>
                    </ul>
                </div> 
                <div class="mainList" *ngIf="afternoonSlots.length !== 0">
                     <h5 class="h6" *ngIf="afternoonSlots.length !== 0">AFTERNOON SLOTS ({{ afternoonSlots.length }})</h5>
                    <ul>
                        <li *ngFor="let afternoonSlot of afternoonSlots; let i=index;">
                            <span>{{ afternoonSlot?.startTime }} - {{afternoonSlot?.endTime }}</span>
                            <span>₹ {{afternoonSlot?.price}}</span>
                        </li>
                    </ul>
                </div>
                <div class="mainList" *ngIf="eveningSlots.length !== 0">
                      <h5 class="h6" *ngIf="eveningSlots.length !== 0">EVENING SLOTS ({{ eveningSlots.length }})</h5>
                    <ul>
                        <li *ngFor="let eveningSlot of eveningSlots; let i=index;">
                            <span>{{ eveningSlot?.startTime }} - {{eveningSlot?.endTime }}</span>
                            <span>₹ {{eveningSlot?.price}}</span>
                        </li>
                    </ul>
                </div>
                <div class="mainList" *ngIf="nightSlots.length !== 0">
                       <h5 class="h6" *ngIf="nightSlots.length !== 0">NIGHT SLOTS ({{ nightSlots.length }})</h5>
                    <ul>
                        <li *ngFor="let nightSlot of nightSlots; let i=index;">
                            <span>{{ nightSlot?.startTime }} - {{nightSlot?.endTime }}</span>
                            <span>₹ {{nightSlot?.price}}</span>
                        </li>
                    </ul>
                </div>
            </div> 
<!--             
            <div class="p-fluid p-formgrid p-grid add-form-padding px-1">
                <h5 class="h6" *ngIf="morningSlots.length !== 0">MORNING SLOTS ({{ morningSlots.length }})</h5>
                <div class="p-field p-col-12 mx-1" *ngFor="let morningSlot of morningSlots; let i=index;">
                    <div class="row p-2">
                        <div class="col-10">
                            <b class="text-secondary mt-2 mx-2">{{ morningSlot?.startTime }} - {{
                                morningSlot?.endTime }}</b>
                        </div>
                        <div class="col-2 d-flex justify-content-end">
                            <p><i class="bx bx-rupee"
                                    style="margin-right: 10px; cursor: pointer;"></i>{{morningSlot?.price}}</p>
                        </div>
                    </div>
                </div>
                <h5 class="h6" *ngIf="afternoonSlots.length !== 0">AFTERNOON SLOTS ({{ afternoonSlots.length }})</h5>
                <div class="p-field p-col-12 mx-1" *ngFor="let afternoonSlot of afternoonSlots; let i=index;">
                    <div class="row p-2">
                        <div class="col-10">
                            <b class="text-secondary mt-2 mx-2">{{ afternoonSlot?.startTime }} - {{
                                afternoonSlot?.endTime }}</b>
                        </div>
                        <div class="col-2 d-flex justify-content-end">
                            <p><i class="bx bx-rupee"
                                    style="margin-right: 10px; cursor: pointer;"></i>{{afternoonSlot?.price}}</p>
                        </div>
                    </div>
                </div>
                <h5 class="h6" *ngIf="eveningSlots.length !== 0">EVENING SLOTS ({{ eveningSlots.length }})</h5>
                <div class="p-field p-col-12 mx-1" *ngFor="let eveningSlot of eveningSlots; let i=index;">
                    <div class="row p-2">
                        <div class="col-10">
                            <b class="text-secondary mt-2 mx-2">{{ eveningSlot?.startTime }} - {{
                                eveningSlot?.endTime }}</b>
                        </div>
                        <div class="col-2 d-flex justify-content-end">
                            <p><i class="bx bx-rupee"
                                    style="margin-right: 10px; cursor: pointer;"></i>{{eveningSlot?.price}}</p>
                        </div>
                    </div>
                </div>
                <h5 class="h6" *ngIf="nightSlots.length !== 0">NIGHT SLOTS ({{ nightSlots.length }})</h5>
                <div class="p-field p-col-12 mx-1" *ngFor="let nightSlot of nightSlots; let i=index;">
                    <div class="row p-2">
                        <div class="col-10">
                            <b class="text-secondary mt-2 mx-2">{{ nightSlot?.startTime }} - {{
                                nightSlot?.endTime }}</b>
                        </div>
                        <div class="col-2 d-flex justify-content-end">
                            <p><i class="bx bx-rupee"
                                    style="margin-right: 10px; cursor: pointer;"></i>{{nightSlot?.price}}</p>
                        </div>
                    </div>
                </div>
            </div> -->

        </p-dialog>
    </div>
</div>